// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/inventory/services/archive',
        component: () =>
            import('@/pages/[organisation]/inventory/services/archive.vue'),
        name: 'inventory.services.archived-services',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.service.update-service',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/services/archive/[id].vue'),
                name: 'inventory.services.view-archived-service',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.service.update-service',
                },
            },
        ],
    },
    {
        path: '/:organisation/inventory/services/import',
        component: () =>
            import('@/pages/[organisation]/inventory/services/import.vue'),
        name: 'inventory.services.import-service-csv',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.service.create-service',
        },
    },
    {
        path: '/:organisation/inventory/services',
        component: () =>
            import('@/pages/[organisation]/inventory/services/index.vue'),
        name: 'inventory.services.search-services',
        meta: {
            loginRequired: true,
            permission: 'access.inventory.service.view-services',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/inventory/services/new.vue'),
                name: 'inventory.services.create-service',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.service.create-service',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/inventory/services/[id].vue'),
                name: 'inventory.services.view-service',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.service.view-services',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/inventory/services/[id]/edit.vue'),
                name: 'inventory.services.update-service',
                meta: {
                    loginRequired: true,
                    permission: 'access.inventory.service.update-service',
                },
            },
        ],
    },
];
